import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Checkmark } from './styles';

const StatusIcon = ({ status }) => {
  let content;

  switch (status) {
    case 'success':
      content = (
        <Fragment>
          <circle className="path circle" fill="none" stroke="#11d17d" strokeWidth="6" strokeMiterlimit="10" cx="65.1" cy="65.1" r="62.1" />
          <polyline className="path check" fill="none" stroke="#11d17d" strokeWidth="6" strokeLinecap="round" strokeMiterlimit="10" points="100.2,40.2 51.5,88.8 29.8,67.5 " />
        </Fragment>
      );
      break;
    case 'alreadyBooked':
      content = <path fill="#ff992c" d="M72.6 90.8c0 4.7-3.1 8.2-8 8.2h-.2c-4.8 0-8-3.5-8-8.3a7.8 7.8 0 0 1 8.1-8.2c4.9 0 8 3.3 8.1 8.3zM59.4 78h10.4l2-41.1H57.4zm68.4 34.7a8.3 8.3 0 0 1-7 4H8.3a8.3 8.3 0 0 1-7.1-12.5L57.6 4a8.2 8.2 0 0 1 7-4h.3A8.2 8.2 0 0 1 72 4.4l56 100.2a8.2 8.2 0 0 1-.2 8zm-7-4.3L64.7 8.2 8.2 108.4z" />;
      break;
    case 'waiting':
      content = <circle className="loader-path" fill="none" stroke="#1eb6ff" strokeWidth="6" strokeMiterlimit="10" cx="65.1" cy="65.1" r="62.1" />;
      break;
    case 'danger':
      content = (
        <Fragment>
          <circle
            className="path circle"
            fill="none"
            stroke="#FF6F5A"
            strokeWidth="6"
            strokeMiterlimit="10"
            cx="65.1"
            cy="65.1"
            r="62.1"
          />
          <line
            className="path line"
            fill="none"
            stroke="#FF6F5A"
            strokeWidth="6"
            strokeLinecap="round"
            strokeMiterlimit="10"
            x1="34.4"
            y1="37.9"
            x2="95.8"
            y2="92.3"
          />
          <line
            className="path line"
            fill="none"
            stroke="#FF6F5A"
            strokeWidth="6"
            strokeLinecap="round"
            strokeMiterlimit="10"
            x1="95.8"
            y1="38"
            x2="34.4"
            y2="92.2"
          />
        </Fragment>
      );
      break;
    default:
      content = null;
  }

  return (
    <Checkmark>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2">
        {content}
      </svg>
    </Checkmark>
  );
};

StatusIcon.propTypes = {
  status: PropTypes.oneOf(['success', 'danger', 'waiting', 'alreadyBooked']),
};

export default StatusIcon;
